import React from 'react'
import { HeadTableDetails, RowLeadsDetail } from "../ui-components";


function TableDetail({lead}) {
  const overridesRegistro = {
    Status:{children: "Registrado"},
    Detail:{children: lead?.channel},
    DateAsignation:{children: lead?.dateRegistry},
    NameAtention:{children: "-"},
    Profile:{children: lead?.channel},
    Comments:{children:" "}
  }

  const overridesAsignation = {
    Status:{children: lead?.status ==="2" ? "Descartado" : "Asignado a Sucursal"},
    Detail:{children: lead?.status ==="2" ? lead?.detail : lead?.branch},
    DateAsignation:{children: lead?.dateAsignation},
    NameAtention:{children: lead?.conekta},
    Profile:{children: "Contact Center"},
    Comments:{children: lead?.comments}
  }

  const overridesManager = {
    Status:{children: lead?.status ==="4" ? "Descartado": `Asignado a Asesor No.:${lead?.isReassigned}`},
    Detail:{children: lead?.status ==="4" ? lead?.detail : lead?.advicer},
    DateAsignation:{children: lead?.dateManager},
    NameAtention:{children: lead?.NameManager},
    Profile:{children: "Gerente"},
    Comments:{children: lead?.CommentManage}
  }

  const overridesAsesor = {
    Status:{children: "Visita"},
    Detail:{children: "Seguimiento con Asesor"},
    DateAsignation:{children: lead?.dateAtencion},
    NameAtention:{children: lead?.advicer},
    Profile:{children: "Asesor"},
    Comments:{children: ""}
  }

  const overridesDescarted = {
    Status:{children: "Descartado"},
    Detail:{children: lead?.detail},
    DateAsignation:{children: lead?.dateAtencion},
    NameAtention:{children: lead?.advicer},
    Profile:{children: "Asesor"},
    Comments:{children: ""}
  }
  const overridesClient= {
    Status:{children: "Prospecto en proceso"},
    Detail:{children: "Seguimiento con Asesor"},
    DateAsignation:{children: lead?.dateAtencion},
    NameAtention:{children: lead?.advicer},
    Profile:{children: "Asesor"},
    Comments:{children: ""}
  }

  return (
    <div>
        <HeadTableDetails width={"100%"}/>
        <RowLeadsDetail leads={lead} width={"100%"} overrides={overridesRegistro}/>
        {lead?.status ==="1" || lead?.status ==="2"  ?
        <RowLeadsDetail leads={lead} width={"100%"} overrides= {overridesAsignation}/> 
        :
        (<>
        <RowLeadsDetail leads={lead} width={"100%"} overrides= {overridesAsignation}/>
        <RowLeadsDetail leads={lead} width={"100%"} overrides={overridesManager} />
        {lead?.status === 5 && <RowLeadsDetail leads={lead} width={"100%"} overrides={overridesDescarted} />}
        {lead?.status === 6 && <RowLeadsDetail leads={lead} width={"100%"} overrides={overridesAsesor} />}
        </>)}
        {lead?.status === 9 && 
        (<>
        <RowLeadsDetail leads={lead} width={"100%"} overrides={overridesAsesor} />
        <RowLeadsDetail leads={lead} width={"100%"} overrides={overridesClient} /> 
        </>)}
    </div>
  )
}

export default TableDetail